export default {
  labels: {
    signed_by: 'Firmato da {{name}} il {{date}}',
    signed_by_no_date: 'Firmato da {{name}}',
  },
  buttons: {
    retry: 'Riprova',
  },
  errors: {
    load_failed: 'Impossibile caricare il contratto. Controlla la connessione e riprova.',
  },
};
